export const STORAGE_KEY_THEME = 'theme';
export const STORAGE_KEY_TOKEN = 'token';
export const STORAGE_KEY_DOC_DETAILS = 'document-details';
export const STORAGE_KEY_LANGUAGE = "language";
export const STORAGE_KEY_TIMEZONE = "timezone";
export const STORAGE_KEY_COLUMN_FILTER = "column-filter";
export const STORAGE_KEY_LAST_GQL_QUERY = "last-gql-query";
export const STORAGE_KEY_PAGE_ITEMS_COUNT = "page-items-count";
export const STORAGE_KEY_PENDING_CHANGE_PROPOSALS= "local-change-proposals";